import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { AlertTriangle, Lock } from "lucide-react";

const CLS = {
  due: "bg-amber-500 text-black", overdue: "bg-orange-600 text-white",
  urgent: "bg-rose-600 text-white", restricted: "bg-rose-700 text-white",
};

// Persistent Owner payment banner — same /billing/me source as the Billing page and Super Admin.
export default function BillingBanner() {
  const { user } = useAuth();
  const { pathname } = useLocation();
  const nav = useNavigate();
  const [b, setB] = useState(null);
  useEffect(() => {
    if (user?.role !== "owner") return;
    api.get("/billing/me").then((r) => setB(r.data)).catch(() => {});
  }, [user?.id, user?.role, pathname]);
  if (user?.role !== "owner" || !b?.banner) return null;
  const { level, text } = b.banner;
  return (
    <div className={`px-4 py-2 text-sm font-semibold flex flex-wrap items-center justify-between gap-2 ${CLS[level]}`} data-testid="billing-banner" data-level={level}>
      <span className="flex items-center gap-2">{level === "restricted" ? <Lock className="w-4 h-4" /> : <AlertTriangle className="w-4 h-4" />}{text}</span>
      {pathname !== "/billing" && <button onClick={() => nav("/billing")} className="underline whitespace-nowrap" data-testid="billing-banner-link">View payment instructions</button>}
    </div>
  );
}
